import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AlarmSosDialogNotificationService {
  private readonly doc = inject(DOCUMENT);

  private readonly audioEl = this.createAudioElement();

  public play(): void {
    this.audioEl.play();
  }

  public stop(): void {
    this.audioEl.pause();
  }

  protected createAudioElement(): HTMLAudioElement {
    const el = this.doc.createElement('audio');
    el.src = '/assets/sound/notification.wav';
    el.loop = true;
    return el;
  }
}
